module.exports = __webpack_public_path__ + "typicons.29f9630f7d87a79830d1.ttf";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/node_modules/typicons.font/src/font/typicons.ttf
// module id = ../../../../typicons.font/src/font/typicons.ttf
// module chunks = styles